import React, { useEffect, useState, useCallback } from "react";
import { Amplify } from "aws-amplify";
import { fetchAuthSession, getCurrentUser, signInWithRedirect, signOut } from "@aws-amplify/auth";
import awsExports from "./aws-exports";
import { Container, Navbar, Nav, Button, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import KeyGenerator from "./components/KeyGenerator";

Amplify.configure({
  Auth: {
    Cognito: {
      region: "eu-west-1",
      userPoolId: "eu-west-1_dVg45Dujp",
      userPoolClientId: "3c75ocghpfuqk82b6aq8fug9an",
      loginWith: {
        oauth: {
          domain: "susadmin.auth.eu-west-1.amazoncognito.com",
          scopes: ["email", "openid", "phone", "profile"],
          redirectSignIn: ["https://susadmin.servqualit.com/"],
          redirectSignOut: ["https://susadmin.servqualit.com/"],
          responseType: "code"
        }
      }
    }
  }
});

function App() {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const session = await fetchAuthSession();
        console.log("Session:", session);

        const token = session?.tokens?.accessToken?.toString();
        console.log("🔐 Access Token:", token);
        setAccessToken(token);

        if (token) {
          const currentUser = await getCurrentUser();
          setUser(currentUser);
          console.log("✅ Logged in:", currentUser);
        } else {
          console.log("🔒 No valid session → redirecting to Hosted UI...");
          await signInWithRedirect();
        }
      } catch (error) {
        console.log("🔒 Not logged in, redirecting to Hosted UI...");
        console.error("Auth error:", error);
        await signInWithRedirect();
      } finally {
        setIsLoading(false);
      }
    };

    checkUser();
  }, []);

  const handleSignOut = useCallback(async () => {
    try {
      await signOut({ global: true });
    } catch (error) {
      console.error("Error signing out:", error);
    }
  }, []);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark text-light">
        <Spinner animation="border" role="status" />
        <span className="ms-3">Checking session...</span>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark text-light">
        <Spinner animation="border" role="status" />
        <span className="ms-3">Redirecting to login...</span>
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand>🔑 SUSAN Key Generator</Navbar.Brand>
          <Nav className="ms-auto">
            <Nav.Link className="text-light">
              {user?.email || user?.signInDetails?.loginId || "User"}
            </Nav.Link>
            <Button variant="outline-light" onClick={handleSignOut} className="ms-2">
              Sign Out
            </Button>
          </Nav>
        </Container>
      </Navbar>

      <Container className="mt-5 pt-5">
        <KeyGenerator user={user} accessToken={accessToken} />
      </Container>
    </div>
  );
}

export default App;
